import { HttpErrorResponse } from '@angular/common/http';
import { ApiError } from '@core/errors/api-error';

export class ServerApiError extends ApiError {
  constructor(cause: HttpErrorResponse, body: unknown) {
    super('ServerApiError', cause, body);
  }
}
